export enum ScreenType {
  Train,
  Team,
  Tryon,
  Design,
  Mannequin,
  Ghost,
  Edit,
  Marketplace,
  TechPack,
  TrendAnalysis,
  StyleTraining,
  ApiAccess,
}

export enum PackageType {
  DesignStarter,
  PhotoshootStarter,
  DesignPro,
  DesignStudio,
  CreativeSuite,
}

export type PopupReason = "credits" | "permissions" | "plan_change" | "";

export interface PaywallContent {
  title: string;
  description: string;
  subtitle: string;
  items: { value: string; text: string }[];
  img: string;
}
